import React, { useContext, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import _ from 'lodash'

import AppConfigContext from '../../../app_layout/app_config_context'
import { ApiHelper } from '../../../../helpers/apihelper'
import * as Constants from '../../../../helpers/constants'
import showToastNotification from '../../../widgets/toastify'

const initialState = {
  showRenewSubscriptionModal: false,
  isRenewingSubscription: false
}

const RenewSubscription = ({ user, product, onSuccess }) => {
  const { client } = useContext(AppConfigContext)
  const [renewSubscriptionState, setRenewSubscriptionState] = useState(initialState)
  if (!user || !product) return null
  const handleRenew = () => {
    const renewUserPlan = ApiHelper(client, 'RENEW_SUBSCRIPTION')
    const requestBody = {
      co_user_id: user.user_id || user._id,
      product_id: product._id
    }
    const body = _.pick(requestBody, renewUserPlan.API_BODY)
    setRenewSubscriptionState(prev => ({ ...prev, isRenewingSubscription: true }))
    renewUserPlan.API(client, body)
      .then(res => {

        if (res?.status === Constants.CO_API.SUCCESS) {

          showToastNotification({
            message: 'Subscription renewed successfully',
            isSuccess: true
          })

          setRenewSubscriptionState(prev => ({ ...prev, showRenewSubscriptionModal: false }))

          if (onSuccess) onSuccess()

        } else {

          showToastNotification({
            message: res?.message || 'Renew failed',
            isSuccess: false
          })

        }
      })
      .catch(err => {
        console.error(err)
        const message = err?.response?.data?.message || err?.message || 'Something went wrong'
        showToastNotification({ message, isSuccess: false })
      })
      .finally(() => setRenewSubscriptionState(prev => ({ ...prev, isRenewingSubscription: false })))
  }
  return (
    <>
      <Button
        size="sm"
        variant="outline-warning"
        onClick={() => setRenewSubscriptionState(prev => ({ ...prev, showRenewSubscriptionModal: true }))}
      >
        Renew
      </Button>
      <Modal
        show={renewSubscriptionState.showRenewSubscriptionModal}
        onHide={() => setRenewSubscriptionState(prev => ({ ...prev, showRenewSubscriptionModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Renew Subscription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to renew{' '}
          <b>{product.display_name}</b> for{' '}
          <b>{user.name}</b>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setRenewSubscriptionState(prev => ({ ...prev, showRenewSubscriptionModal: false }))}
            disabled={renewSubscriptionState.isRenewingSubscription}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleRenew}
            disabled={renewSubscriptionState.isRenewingSubscription}
          >
            {renewSubscriptionState.isRenewingSubscription ? 'Renewing...' : 'Confirm'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default RenewSubscription
